import { IRestUrlConfig } from '../../Contracts/UI/Resource/IResourceConfig'

/**
 * Замінює параметри в URI строці
 * @param uri - URI строка з параметрами у форматі {param}
 * @param params - об'єкт з параметрами для заміни
 * @returns URI з замінними параметрами або null якщо uri не є строкою
 */
const replaceParamsFn = (uri: string, params: Record<string, any>): string | null => {
    if (typeof uri !== 'string') {
        return null
    }

    if (Object.keys(params).length === 0) {
        return uri
    }

    let result = uri
    Object.keys(params).forEach((key) => {
        result = result.replace(`{${key}}`, params[key])
    })

    return result
}

/**
 * Отримує REST URI для заданого типу операції
 * @param restUrl - конфігурація REST URI (строка або об'єкт IrestUrlConfig)
 * @param type - тип операції (getCollection, get, post, patch, delete тощо)
 * @param replaceParams - параметри для заміни в URI
 * @returns готовий URI або null якщо не знайдено відповідний endpoint
 */
export const GetRestUrlTask = (
    restUrl: string | IRestUrlConfig | undefined,
    type: string = 'getCollection',
    replaceParams: Record<string, any> = {}
): string | null => {
    let uri: string | null = null

    // Якщо restUrl є строкою - використовуємо її напряму
    if (typeof restUrl === 'string') {
        uri = restUrl
    }

    // Якщо restUrl є об'єктом - беремо відповідний endpoint
    if (typeof restUrl === 'object' && restUrl && typeof restUrl[type] === 'string') {
        uri = restUrl[type] as string
    }

    if (!uri) {
        return null
    }

    // Додаємо /{id} для операцій з конкретним ресурсом
    if (['put', 'patch', 'get', 'delete'].includes(type) && !uri.endsWith('/{id}')) {
        uri = `${uri}/{id}`
    }

    return replaceParamsFn(uri, replaceParams)
}
